import Box from '@mui/material/Box';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import BottomNavigationBar from '../../components/Layouts/BottomNavigationBar/BottomNavigationBar';
import Footer from '../../components/Layouts/Footer/Footer';
import LayoutSingleColumn from '../../components/Layouts/LayoutSingleColumn';
import LayoutWrapperBottombar from '../../components/Layouts/LayoutWrapperBottombar/LayoutWrapperBottombar';
import LayoutWrapperFooter from '../../components/Layouts/LayoutWrapperFooter/LayoutWrapperFooter';
import LayoutWrapperMain from '../../components/Layouts/LayoutWrapperMain';
import LayoutWrapperTopbar from '../../components/Layouts/LayoutWrapperTopbar/LayoutWrapperTopbar';
import Page from '../../components/Page/Page';
import { FormattedMessage } from '../../util/reactIntl';
import { errorTextSx } from './listingPageStyles';

/**
 * This component is shown when the listing data loading has failed.
 * @param {object} props
 * @param {React.JSX.Element} props.topbar - TopBar component.
 * @returns {React.JSX.Element}
 */

const ListingPageErrorComponent = ({ topbar }) => {
  const intl = useIntl();

  const errorTitle = intl.formatMessage({
    id: 'ListingPage.errorLoadingListingTitle',
  });

  return (
    <Page title={errorTitle}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <Box component="p" sx={errorTextSx}>
            <FormattedMessage id="ListingPage.errorLoadingListingMessage" />
          </Box>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
        <LayoutWrapperBottombar>
          <BottomNavigationBar />
        </LayoutWrapperBottombar>
      </LayoutSingleColumn>
    </Page>
  );
};

const ListingPageError = memo(ListingPageErrorComponent);
ListingPageError.displayName = 'ListingPageError';

export default ListingPageError;
